import { IconButton } from "@mui/material"
import { IconMessageQuestion } from "@tabler/icons-react"
import { useAuthContext } from "../../../contexts/AuthContext"

const AyudaButton = () => {

    const { user } = useAuthContext()

    const onPress = () => {

        window?.smartsupp('variables', {
            Sistema: "IR Nube",
            PerfilIR : user?.rol?.ro_descripcion || '?',
            ClienteIR : user?.cliente?.cl_descripcion || '?'
        })

        window?.smartsupp('chat:show')
        window?.smartsupp('chat:open')
        window?.smartsupp('name', user?.name || 'Desconocido')
        window?.smartsupp('email', user?.email || '')
        window?.smartsupp('phone', user?.celular || '');
    }

    return (
        <IconButton type="button" onClick={onPress}>
            <IconMessageQuestion />
        </IconButton>
    )
}
export { AyudaButton }